var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"User Timeline"}},[_c('app-timeline',[_c('app-timeline-item',{attrs:{"variant":"info","title":_vm.$t('action.edit'),"subtitle":_vm.$t('action.edit'),"time":_vm.$t('common.today')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }